<script>
	import { onMount } from 'svelte';

	import Router from 'svelte-spa-router';

	import routes from './routes.js';

	let navToggled = false;

	let scroll = 0;

    onMount(() => {
		const page = document.getElementById('page-wrap');
		page.addEventListener('scroll', () => {
			scroll = page.scrollTop;
		});
	});
</script>

<nav class="navbar navbar-expand-lg fixed-top navbar-dark {(scroll > 0 || navToggled)? 'bg-translucent':''}">
	<div class="container-fluid">
		<a class="navbar-brand d-none d-md-block" href="#">wangsichun studio</a>
		<button
			class="navbar-toggler btn btn-primary"
			type="button"
			on:click="{() => navToggled = !navToggled}">
			<span class="navbar-toggler-icon" />
		</button>

		<div class="{navToggled === true ? '' : 'collapse'} navbar-collapse">
			<ul class="navbar-nav me-auto mb-2 mb-lg-0">
				<li class="nav-item">
					<a
						href="/"
						on:click="{() => navToggled = !navToggled}"
						class="nav-link">
						Home
					</a>
				</li>

				<li class="nav-item">
					<a
						href="#/studio"
						on:click="{() => navToggled = !navToggled}"
						class="nav-link">
						Studio
					</a>
				</li>

				<li class="nav-item">
					<a
						href="#/illustrations"
						on:click="{() => navToggled = !navToggled}"
						class="nav-link">
						Illustrations
					</a>
				</li>

				<li class="nav-item">
					<a
						href="#/contact"
						on:click="{() => navToggled = !navToggled}"
						class="nav-link">
						Contact
					</a>
				</li>
			</ul>
		</div>
	</div>
</nav>

<div
	class="wrapper">
	<div
		class="page" id="page-wrap">
		<Router {routes} />

		<footer class="footer bg-dark text-light text-center p-3 font-VarelaRound">
			&copy; wangsichun studio 2022
		</footer>
	</div>
</div>

<style lang="scss" global>
	@import "src/scss/portfolio";

	.bg-translucent {
		/* background: rgba(0, 0, 0, 0.6); */
		background: $black;
	}

	.footer {
		width: 100%;
	}
</style>
